import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { UpArrowIcon } from '../../icons';
import { Button } from '../button';
import { Text } from '../text';
export var AccordionItem = function (_a) {
    var label = _a.label, children = _a.children, _b = _a.isOpen, isAccordionItemOpen = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.headerClassName, headerClassName = _d === void 0 ? '' : _d, _e = _a.containerClassName, containerClassName = _e === void 0 ? '' : _e, onToggle = _a.onToggle, _f = _a.labelVariant, labelVariant = _f === void 0 ? 'default' : _f;
    var _g = useState(isAccordionItemOpen), isOpen = _g[0], setIsOpen = _g[1];
    var handleToggle = function () {
        if (onToggle) {
            onToggle(!isOpen);
        }
        setIsOpen(!isOpen);
    };
    useEffect(function () {
        setIsOpen(isAccordionItemOpen);
    }, [isAccordionItemOpen]);
    return (_jsxs("div", { className: className, children: [_jsxs("div", { className: "flex justify-between items-center ".concat(headerClassName), onClick: handleToggle, children: [typeof label === 'string' ? _jsx(Text, { variant: labelVariant, children: label }) : label, _jsx(Button, { variant: 'text', onClick: handleToggle, className: 'flex items-center justify-between rounded-none', children: _jsx(UpArrowIcon, { rotate: !isOpen ? 180 : 0 }) })] }), isOpen && (_jsx("div", { className: "transition-all duration-200 ".concat(containerClassName), children: children }))] }));
};
